export const environment = {
    envConfig: {
        coreApiUrl: 'https://portal-dev.papercast.net/core',
        oidcAuthority: 'https://sso-dev.papercast.net',
        oidcRedirectUri: 'https://portal-dev.papercast.net',
        oidcPostLogoutRedirectUri: 'https://portal-dev.papercast.net/logout',
        oidcRealm: 'development',
        oidcClientId: 'frontend',
        weatherApiKey: 'ed29b8f34fa201326a021fdc357d75e1',
        weatherCity: 'London,GB',
        cartoApiKey: 'cb1_2add_1_ba3f65d875b0fb6dabdc0c35',
    }
};
